
class MemorySystem {
  framework;
  //nexusAddress = "mundoimperial.checkin.world";
  //nexusAddress = "10.0.0.9";
  nexusAddress = "serv3.checkin.world";
  //nexusAddress = "localhost";
  nexusPort = 9443;
  //originUrl = "https://mundoimperial.checkin.world";
  //originUrl = "https://10.0.0.9:19443";
  originUrl = "https://serv3.checkin.world:11443";
  //originUrl = "https://localhost";
  referenceCatalogStorage = null;

  constructor(_framework) {
    this.framework = _framework;
  }


  getNexusUrl() {
    return "https://" + this.nexusAddress +":" + this.nexusPort;
  }

  getOrigin() {
    return this.originUrl;
  }  

  getFramework() {
    return this.framework;
  }

  getNexusAddress() {
      return this.nexusAddress;
  }

  getNexusPort() {
    return this.nexusPort;
  }

  getReferenceCatalogStorage() {
    let referenceCatalogStorageString = window.localStorage.getItem("referenceCatalogStorage");
    console.log(referenceCatalogStorageString);    
    if(referenceCatalogStorageString !== undefined && referenceCatalogStorageString !== null)  {
      if("undefined" === referenceCatalogStorageString) {
        return null;
      }
      return JSON.parse(referenceCatalogStorageString);
    }
    return null;
  }

  setNexusAddress(newNexusAddress) {
    this.nexusAddress = newNexusAddress;    
  }

  setNexusPort(newNexusPort) {
    this.nexusPort = newNexusPort;    
  }

  setReferenceCatalogStorage(referenceCatalogStorage) {
    if(referenceCatalogStorage !== undefined && referenceCatalogStorage !== null) {
      let referenceCatalogStorageString = JSON.stringify(referenceCatalogStorage);
      return window.localStorage.setItem("referenceCatalogStorage",referenceCatalogStorageString);
    }
  }
}


export default MemorySystem;